module.exports = __webpack_public_path__ + "static/work-tasks-0a21c196c7aabc83eb6b54d566c33a55.png";